import { connect } from 'react-redux';
import { Dispatch } from 'redux';

import { Action } from '../../actions';
import {
    changeCopiedRetargetingRulesTooltipStatus,
    copyRetargetingRulesInfoToClipboard
} from '../../actions/grid-screen';
import { UsersProfileConditionInfo } from '../../components/UsersProfileConditionInfo/UsersProfileConditionInfo';
import { UsersProfileConditionInfoProps } from '../../components/UsersProfileConditionInfo/UsersProfileConditionInfo';
import {
    CopyTooltipStatus,
    RetargetingConditionRule
} from '../../typings/domain';
import { State } from '../../typings/state';
import { UserProfileCondition } from '../../typings/userProfileRetargeting';
import { TDispatchProps, TStateProps } from '../../typings/utils';

type StateProps = TStateProps<UsersProfileConditionInfoProps, OwnProps>;
type DispatchProps = TDispatchProps<UsersProfileConditionInfoProps>;

export type OwnProps = {
    metrikaAudienceGoals: RetargetingConditionRule[];
    userProfileConditions: UserProfileCondition[];
    isHasConditions: boolean;
};

const mapStateToProps = (state: State): StateProps => {
    const { copyTooltipStatus } = state.grid.retargetingRulesInfo;

    return {
        copyTooltipStatus
    };
};

const mapDispatchToProps = (dispatch: Dispatch<Action>): DispatchProps => {
    return {
        onCopyClick: (text: string) => {
            dispatch(copyRetargetingRulesInfoToClipboard(text));
        },
        onPopupOpen: () => {
            dispatch(
                changeCopiedRetargetingRulesTooltipStatus(
                    CopyTooltipStatus.hidden
                )
            );
        }
    };
};

export const UsersProfileConditionsContainer = connect<
    StateProps,
    DispatchProps,
    OwnProps
>(
    mapStateToProps,
    mapDispatchToProps
)(UsersProfileConditionInfo);
